// initial state
const state = () => ({
	models: [],
	selectedModel: null
})


// actions
const actions = {

	setModels({ commit }, value)
	{
		commit('setModels', value);
	},

	setSelectedModel({ commit }, value)
	{
		commit('setSelectedModel', value);
	},

	setSelectedModelFromModelName({ commit }, value)
	{
		commit('setSelectedModelFromModelName', value);
	},
}

// getters
const getters = {

}

// mutations
const mutations = {

	setModels(state, value)
	{
		state.models = value
		state.selectedModel = value[0]
	},

	setSelectedModel(state, value)
	{
		state.selectedModel = value
	},

	setSelectedModelFromModelName(state, value)
	{
		const index = state.models.findIndex((x) =>
		{
			return x.modelName == value
		});

		if (index > -1)
		{
			state.selectedModel = state.models[index]
		}
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
